import { useState } from 'preact/hooks'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import styles from './subtitles.module.css'

/** The spoken line, bottom center. The last line stays up while it fades out. */
export function Subtitles() {
  const t = useT()
  const enabled = useView((view) => view.settings.accessibility.subtitles)
  const subtitle = useView((view) => view.hud.subtitle)
  const raised = useView((view) => view.inventory !== null)
  const [shown, setShown] = useState(subtitle)
  if (!enabled) return null
  if (subtitle !== null && subtitle !== shown) setShown(subtitle)
  if (!shown?.text) return null

  const lineKey = 'raw' in shown.text ? shown.text.raw : shown.text.key

  return (
    <div
      class={styles.subtitle}
      data-open={subtitle !== null || undefined}
      data-raised={raised || undefined}
      aria-live="polite"
      aria-hidden={subtitle === null}
    >
      {shown.speaker && <p class={styles.speaker}>{t(shown.speaker)}</p>}
      <p key={lineKey} class={styles.text}>
        {t(shown.text)}
      </p>
    </div>
  )
}
